import { Box, Grid } from '@material-ui/core';

import messages from 'containers/AppContainer/messages';
import noNotification from 'images/no-notification.svg';
import styled from 'styled-components';
import React from 'react';
import { translate } from 'containers/services/translate';
import { IntlShape, injectIntl } from 'react-intl';

export const StyledEmptyMessage = styled.div`
  color: #9797af;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
`;
const NotificationEmptyBloc = (props: { intl: IntlShape }) => {
  return (
    <Box padding={8}>
      <Grid
        container
        alignItems="center"
        justify="center"
        direction="column"
        spacing={2}
      >
        <Grid item>
          <img alt="no-notifications" src={noNotification} />
        </Grid>
        <StyledEmptyMessage>
          {translate({ ...messages.emptyMessage }, props)}
        </StyledEmptyMessage>
      </Grid>
    </Box>
  );
};

export default injectIntl(NotificationEmptyBloc);
